
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const fontApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listFonts: builder.query ({
      query: (params) => `v2/font/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Font"]
    }),
    getFont: builder.query ({
      query: (font_id) => `v2/font/${font_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Font"]
    }),
    getFontVariations: builder.query ({
      query: (font_id) => `v2/fontreference/?parent=${font_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["FontReference"]
    }),
    getFontParents: builder.query ({
      query: (font_id) => `v2/fontreference/?font=${font_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["FontReference"]
    }),
    updateFont: builder.mutation ({
      query: ({font_id, data}) => ({
        url: `v2/font/${font_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Font"]
    }),
    deleteFont: builder.mutation ({
      query: (font_id) => ({
        url: `v2/font/${font_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Font"]
    }),
    createFont: builder.mutation ({
      query: (data) => ({
        url: `v2/font/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Font"]
    }),
  })
})


export const {
  useListFontsQuery,
  useLazyListFontsQuery,
  useGetFontQuery,
  useLazyGetFontQuery,
  useGetFontVariationsQuery,
  useGetFontParentsQuery,
  useUpdateFontMutation,
  useDeleteFontMutation,
  useCreateFontMutation
} = fontApi
